import FormBuilderConfig from "../../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IUserSelectorBuilder from "../../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import IDateBuilder from "../../../../../toolkit/baseForms2/iDateBuilder/IDateBuilder";
import IButtonBuilder from "../../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

type Inputs = "coordinador" | "fechaInicio";
type Buttons = "aceptar" | "cancelar";

export const programaCedulaFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "coordinador",
      label: "Coordinador de club",
      bts: {
        xCol: 12
      },
      component: IUserSelectorBuilder
    },
    {
      name: "fechaInicio",
      label: "Fecha de inicio",
      bts: {
        xCol: 12
      },
      component: IDateBuilder
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Aceptar",
      isSubmit: true,
      bts: {
        mCol: 3,
        mOff: 6
      },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: {
        mCol: 3
      },
      component: IButtonBuilder
    }
  ],
  validations: {
    coordinador: {
      required: true
    },
    fechaInicio: {
      required: true
    }
  },
  rows: [["coordinador", "fechaInicio", "aceptar", "cancelar"]]
};
